import { z } from "zod";

const NullableStringSchema = z.string().nullable().optional();
const NullableOwnerIdSchema = z.union([z.string(), z.number()]).nullable().optional();

export const CrmTypeSchema = z.enum(["ZOHO", "HUBSPOT", "PIPEDRIVE", "MSDYNAMICS", "SALESFORCE"]);

export const CrmDealInfoSchema = z
	.object({
		id: z.number(),
		prospectId: z.number(),
		companyId: z.number(),
		crmType: CrmTypeSchema,
		referenceId: z.string(),
		url: z.string().nullable(),
		dealName: NullableStringSchema,
		dealStage: NullableStringSchema,
		pipeline: NullableStringSchema,
		dealOwner: NullableStringSchema,
		dealOwnerId: NullableStringSchema,
		syncStatus: NullableStringSchema,
		syncError: NullableStringSchema,
		lastUpdatedAt: NullableStringSchema,
		closeDate: NullableStringSchema,
		createdAt: z.string(),
		updatedAt: z.string(),
	})
	.passthrough();

export const CrmProspectInfoSchema = z
	.object({
		id: z.number(),
		prospectId: z.number(),
		companyId: z.number(),
		crmType: CrmTypeSchema,
		url: z.string().nullable(),
		currentStatus: NullableStringSchema,
		accountOwner: NullableStringSchema,
		accountOwnerId: NullableOwnerIdSchema,
		referenceId: NullableStringSchema,
		lastUpdatedAt: NullableStringSchema,
		customField1: NullableStringSchema,
		customField2: NullableStringSchema,
	})
	.passthrough();

export const CrmOrganizationInfoSchema = z
	.object({
		id: z.number(),
		organizationId: z.number(),
		companyId: z.number(),
		crmType: CrmTypeSchema,
		url: z.string().nullable(),
		accountOwner: NullableStringSchema,
		accountOwnerId: NullableOwnerIdSchema,
		referenceId: NullableStringSchema,
		lastUpdatedAt: NullableStringSchema,
		customField1: NullableStringSchema,
		customField2: NullableStringSchema,
	})
	.passthrough();

export const CrmDealCreationResultSchema = z.object({
	crmDeal: CrmDealInfoSchema,
	crmProspect: CrmProspectInfoSchema.nullable(),
	crmOrganization: CrmOrganizationInfoSchema.nullable(),
});

export type CrmDealCreationResult = z.infer<typeof CrmDealCreationResultSchema>;
